<app-page-loader></app-page-loader>
<block-ui>
  <router-outlet></router-outlet>
</block-ui>
